import React from 'react';
import { modelClass } from '/imports/api/musers';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { useUser } from '/imports/hooks';

export const MUsersPage = () => (
  <ModelListPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    columns={[{ field: '_id', label: 'UID', className: 'mono' }, { field: 'name', label: 'Name' }, { field: 'email', label: 'Email' }, { field: 'clan', label: 'Clan' }, {
      field: 'credit', label: 'Credit', className: 'mono',
      // Sum of the fleet-scoped pots; pre-migration rows fall back to the
      // legacy flat field so the column never goes blank during rollout.
      render: (m) => {
        const credits = (m as any).credits as Record<string, number> | undefined;
        const total = credits
          ? Object.values(credits).reduce((a, b) => a + (Number(b) || 0), 0)
          : Number((m as any).credit) || 0;
        return <span className="font-mono tabular-nums">{Math.round(total * 100000) / 100000}</span>;
      },
    }]}
  />
);

// keep unused import live so tree-shaking doesn't drop the hook
void useUser;
